import {
  CheckCircleIcon,
  ExclamationTriangleIcon,
} from '@heroicons/react/24/solid';

interface ValidationSummaryProps {
  canExecute: boolean;
  message: string;
}

/**
 * ValidationSummary - Footer component showing validation status
 *
 * Displays a message with appropriate icon indicating whether
 * the capability is ready to execute or what needs to be fixed.
 * Uses aria-live to announce changes to screen readers.
 */
export function ValidationSummary({
  canExecute,
  message,
}: ValidationSummaryProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      className={`flex items-center gap-2 ${canExecute ? 'text-green-600' : 'text-amber-500'}`}
    >
      {canExecute ? (
        <CheckCircleIcon
          className="size-5"
          data-testid="validation-ready-icon"
          aria-hidden="true"
        />
      ) : (
        <ExclamationTriangleIcon
          className="size-5"
          data-testid="validation-warning-icon"
          aria-hidden="true"
        />
      )}
      <span className="text-sm font-medium">{message}</span>
    </div>
  );
}
